export const Bio = {
  name: "Shashank Singh",
  roles: ["Frontend Developer", "ReactJS Developer", "MERN Stack Developer"],
  description:
    "Senior Frontend Developer with 4+ years of experience building scalable, high-performance web applications using React.js (Hooks, Context API, Redux), Next.js, and Angular. Proven track record of automating 80%+ of manual workflows and improving user satisfaction by 20%+ in enterprise environments. Deep expertise in component-based architecture, state management, REST API integration, performance optimization (Core Web Vitals, lazy loading, memoization), and responsive UI development. Strong cross-browser compatibility awareness and accessibility (WCAG) practices. Actively expanding DSA knowledge to write more efficient JavaScript/TypeScript logic. Experienced with Jenkins deployment, Resolving SonarQube Issues and AI-assisted development workflows in Agile teams.",
  github: "https://github.com/savitaar0912",
  resume:
    "https://drive.google.com/drive/folders/1CIuoHteugsp2G9uce4qK_o0OYdono0wW?usp=drive_link",
  linkedin: `https://www.linkedin.com/in/singhshashank875/`,
  twitter: "https://twitter.com/savitaar875",
  insta: "https://www.instagram.com/_savitaar_/",
  facebook:
    "https://www.facebook.com/profile.php?viewas=100000686899395&id=100005332446091",
  youtube: "https://yt.openinapp.co/6p5ek",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React.js (Hooks, Redux)",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Next.js",
        image:
          "https://www.drupal.org/files/project-images/nextjs-icon-dark-background.png",
      },
      {
        name: "Angular",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQudh5nycYRnJoOsDYIMdoSkkyBLyrovgIEJw&s",
      },
      {
        name: "Component Architecture",
        image:
          "https://ui-avatars.com/api/?name=CA&background=1e293b&color=fff&rounded=true&bold=true",
      },
      {
        name: "Micro-frontends",
        image:
          "https://ui-avatars.com/api/?name=MF&background=1e293b&color=fff&rounded=true&bold=true",
      },
    ],
  },
  {
    title: "Languages",
    skills: [
      {
        name: "JavaScript (ES6+)",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQiXhjVqtRd6tiqcsSQ7rD6VF7NxI-3VvoR0w&s",
      },
      {
        name: "TypeScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/4/4c/Typescript_logo_2020.svg",
      },
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
    ],
  },
  {
    title: "Testing & Quality",
    skills: [
      {
        name: "Unit Testing",
        image:
          "https://ui-avatars.com/api/?name=UT&background=1e293b&color=fff&rounded=true&bold=true",
      },
      {
        name: "SonarQube",
        image:
          "https://cdn.iconscout.com/icon/free/png-256/free-sonarqube-logo-icon-download-in-svg-png-gif-file-formats--technology-social-media-company-brand-vol-6-pack-logos-icons-2945203.png",
      },
      {
        name: "Code Reviews",
        image:
          "https://ui-avatars.com/api/?name=CR&background=1e293b&color=fff&rounded=true&bold=true",
      },
    ],
  },
  {
    title: "UI & Styling",
    skills: [
      {
        name: "HTML5",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS3",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/css3/css3-original.svg",
      },
      {
        name: "Tailwind CSS",
        image: "https://www.drupal.org/files/project-images/screenshot_361.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Material UI (MUI)",
        image:
          "data:image/png;base64,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",
      },
      {
        name: "Carbon Design System",
        image:
          "https://ui-avatars.com/api/?name=CDS&background=1e293b&color=fff&rounded=true&bold=true",
      },
      {
        name: "Responsive Design",
        image:
          "https://ui-avatars.com/api/?name=RD&background=1e293b&color=fff&rounded=true&bold=true",
      },
      {
        name: "WCAG/Accessibility",
        image:
          "https://ui-avatars.com/api/?name=AC&background=1e293b&color=fff&rounded=true&bold=true",
      },
    ],
  },
  {
    title: "Backend & APIs",
    skills: [
      {
        name: "Node.js",
        image: "https://www.mindrops.com/images/nodejs-image.webp",
      },
      {
        name: "Express.js",
        image:
          "https://ajeetchaulagain.com/static/7cb4af597964b0911fe71cb2f8148d64/87351/express-js.png",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "REST APIs",
        image:
          "https://ui-avatars.com/api/?name=API&background=1e293b&color=fff&rounded=true&bold=true",
      },
      {
        name: "API Integration",
        image:
          "https://ui-avatars.com/api/?name=AI&background=1e293b&color=fff&rounded=true&bold=true",
      },
      {
        name: "Authentication",
        image:
          "https://ui-avatars.com/api/?name=Auth&background=1e293b&color=fff&rounded=true&bold=true",
      },
      {
        name: "Stripe.js",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/b/ba/Stripe_Logo%2C_revised_2016.svg",
      },
    ],
  },
  {
    title: "Performance",
    skills: [
      {
        name: "Lazy Loading",
        image:
          "https://ui-avatars.com/api/?name=LL&background=1e293b&color=fff&rounded=true&bold=true",
      },
      {
        name: "Memoization",
        image:
          "https://ui-avatars.com/api/?name=Mem&background=1e293b&color=fff&rounded=true&bold=true",
      },
      {
        name: "Code Splitting",
        image:
          "https://ui-avatars.com/api/?name=CS&background=1e293b&color=fff&rounded=true&bold=true",
      },
      {
        name: "Core Web Vitals",
        image:
          "https://ui-avatars.com/api/?name=CWV&background=1e293b&color=fff&rounded=true&bold=true",
      },
    ],
  },
  {
    title: "Tools & DevOps",
    skills: [
      {
        name: "Git",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "https://www.vectorlogo.zone/logos/getpostman/getpostman-icon.svg",
      },
      {
        name: "Swagger",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/swagger/swagger-original.svg",
      },
      {
        name: "Thunder Client",
        image:
          "https://rangav.gallerycdn.vsassets.io/extensions/rangav/vscode-thunder-client/2.33.1/1734381361338/Microsoft.VisualStudio.Services.Icons.Default",
      },
      {
        name: "Jenkins",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/e/e9/Jenkins_logo.svg",
      },
      {
        name: "SonarQube",
        image:
          "https://cdn.iconscout.com/icon/free/png-256/free-sonarqube-logo-icon-download-in-svg-png-gif-file-formats--technology-social-media-company-brand-vol-6-pack-logos-icons-2945203.png",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
    ],
  },
  {
    title: "Methodologies",
    skills: [
      {
        name: "Agile",
        image:
          "https://ui-avatars.com/api/?name=Ag&background=1e293b&color=fff&rounded=true&bold=true",
      },
      {
        name: "Scrum",
        image:
          "https://ui-avatars.com/api/?name=Sc&background=1e293b&color=fff&rounded=true&bold=true",
      },
      {
        name: "Performance Optimization",
        image:
          "https://ui-avatars.com/api/?name=PO&background=1e293b&color=fff&rounded=true&bold=true",
      },
      {
        name: "Reusable Components",
        image:
          "https://ui-avatars.com/api/?name=RC&background=1e293b&color=fff&rounded=true&bold=true",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://www.ibm.com/brand/experience-guides/developer/b1db1ae501d522a1a4b49613fe07c9f1/01_8-bar-positive.svg",
    role: "Frontend Developer (Angular / React)",
    company: "IBM",
    date: "Sep 2024 - Present",
    desc: "Built and optimized 15+ complex UI modules for a multi-cloud migration platform using Angular, React.js, TypeScript, and Carbon Design System. Engineered advanced filtering, search, and multi-select components, reducing application discovery time by ~35%. Optimized rendering performance of large cloud-discovery API datasets, reducing average page load time by ~40%. Integrated 10+ REST APIs for real-time migration tracking. Leveraged AI-assisted development to accelerate reusable component generation by ~25%. Maintained cross-browser compatibility and ensured WCAG 2.1 accessibility compliance.",
    skills: [
      "Angular",
      "TypeScript",
      "React JS",
      "NextJS",
      "JavaScript",
      "HTML",
      "Carbon Design System",
      "Tailwind CSS",
      "MUI",
      "Redux",
      "API Integration",
      "Agile Methodology",
    ],
  },
  {
    id: 1,
    img: "https://cdn-ukwest.onetrust.com/logos/8d84415b-1b52-4bc4-8d5f-ca9a8eccaf8a/f7db8968-fc22-4620-92ac-dc05c5d2aa15/02460a41-565e-4cac-80a7-449bc8f77a72/logo-infosys.png",
    role: "Senior Frontend Developer(React/NextJS)",
    company: "Infosys Ltd.",
    date: "Jan 2024 - Sept 2024",
    desc: "Architected and delivered a full-stack internal Next.js dashboard used by leadership to track demand/supply, interview pipelines, onboarding, and skill availability. Built 20+ interactive data visualization components (charts, graphs, dynamic tables). Automated key staffing insights, reducing manual reporting effort by ~50%. Implemented performant API communication and optimized rendering for large datasets, achieving consistent sub-2-second load times. Collaborated with cross-functional teams to integrate RESTful APIs for real-time organizational data.",
    skills: [
      "Next JS",
      "React JS",
      "Material UI",
      "JavaScript",
      "Node JS",
      "Express JS",
    ],
  },
  {
    id: 2,
    img: "https://cdn-ukwest.onetrust.com/logos/8d84415b-1b52-4bc4-8d5f-ca9a8eccaf8a/f7db8968-fc22-4620-92ac-dc05c5d2aa15/02460a41-565e-4cac-80a7-449bc8f77a72/logo-infosys.png",
    role: "Frontend Developer(ReactJS)",
    company: "Infosys Ltd.",
    date: "Oct 2021 - Dec 2023",
    desc: "Developed the React.js frontend for a unified communications migration tool managing licenses, user accounts, and policy assignments. Automated 80%+ of previously manual UC admin processes by building modules for dial plan validation and voice policy configuration, saving ~200+ hours/month. Contributed to a 20% increase in user satisfaction by transforming complex backend UC logic into intuitive UI flows. Contributed to SfB to Microsoft Teams migration and authored PowerShell automation scripts to reduce repetitive admin tasks by ~30%.",
    skills: [
      "HTML",
      "CSS",
      "Bootstrap",
      "Material UI",
      "JavaScript",
      "MongoDB",
      "Node JS",
      "Express JS",
      "React JS",
      "Redux",
    ],
  },
];

export const education = [
  {
    id: 0,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT9TmXKDmXfnLj0ND0p0rj2SE2FrtCNgECm8A&s",
    school: "Pranveer Singh Institute of Technology, Kanpur",
    date: "Aug 2017 - May 2021",
    grade: "8.1 GPA",
    desc: "I completed my Bachelor's degree at Pranveer Singh Institute of Technology, Kanpur in 2021. I did training in Python, C and also good knowledge of SQL queries",
    degree: "Bachelor of Technology - BTech",
  },
  {
    id: 1,
    img: "https://www.schoolskey.com/uploads/thumb/29823_shreesdecupklogo33.png",
    school: "SSDEC, Kanpur",
    date: "Apr 2016 - Apr 2017",
    grade: "83%",
    desc: "I completed my Intermediate from SSDEC, Kanpur, where I studied Science(PCM).",
    degree: "CBSE(XII), Science(PCM)",
  },
  {
    id: 2,
    img: "https://www.schoolskey.com/uploads/thumb/29823_shreesdecupklogo33.png",
    school: "SSDEC, Kanpur",
    date: "Apr 2014 - Apr 2015",
    grade: "90%",
    desc: "I completed my High School from SSDEC, Kanpur.",
    degree: "CBSE(XII)",
  },
];

export const projects = [
  {
    id: -1,
    title: "Consulting Delivery Curator — Multi-Cloud Migration Platform [IBM]",
    role: "Frontend Developer (Angular / React)",
    date: "Sep 2024 - Present",
    description:
      "Built and optimized 15+ complex UI modules for a multi-cloud migration platform serving enterprise users across AWS, GCP, and Azure. Engineered advanced filtering, search, and multi-select components, reducing discovery time by 35%. Optimized rendering of large API datasets, reducing load time by 40%. Integrated 10+ REST APIs for real-time tracking.",
    image:
      "https://www.ibm.com/brand/experience-guides/developer/b1db1ae501d522a1a4b49613fe07c9f1/01_8-bar-positive.svg",
    tags: [
      "Angular",
      "React.js",
      "TypeScript",
      "Carbon Design System",
      "AWS",
      "GCP",
      "Azure",
      "REST APIs",
    ],
    category: "",
    github: "",
  },
  {
    id: 0,
    title: "Demand and Supply Management System [INFOSYS LTD.]",
    role: "Senior Developer",
    date: "Role-specific date if available",
    description:
      "Architected and delivered a full-stack internal Next.js dashboard used by leadership to track demand/supply, interview pipelines, onboarding, and skill availability. Built 20+ interactive data visualization components. Automated key staffing insights, reducing manual reporting effort by ~50%. Implemented performant API communication and optimized rendering for large datasets, achieving consistent sub-2-second load times.",
    image:
      "https://www.researchgate.net/publication/361830584/figure/fig3/AS:11431281084474354@1663208015300/Graph-of-Growth-in-Technical-Skills.png",
    tags: [
      "Next.js",
      "React",
      "Node.js",
      "MongoDB",
      "Recharts",
      "MUI",
      "x-charts",
    ],
    category: "",
    github: "", // Add GitHub URL if available
  },
  {
    id: 1,
    title: "UC Suits - Migration Manager Tool [UBS SWITZERLAND AG.]",
    role: "Frontend Developer",
    date: "Role-specific date if available",
    description:
      "Developed the React.js frontend for a unified communications migration tool managing licenses, user accounts, and policy assignments. Automated 80%+ of previously manual UC admin processes by building modules for dial plan validation and voice policy configuration, saving ~200+ hours/month. Contributed to a 20% increase in user satisfaction by transforming complex backend UC logic into intuitive UI flows.",
    image:
      "https://thumbs.dreamstime.com/b/d-shield-icon-glowing-confidential-text-representing-data-security-341031150.jpg",
    tags: ["React", "Redux"],
    category: "",
    github: "", // Add GitHub URL if available
  },
  {
    id: 2,
    title:
      "Migration from SfB to MS Teams - Configure Teams [CREDIT SUISSE AG]",
    role: "Systems Engineer",
    date: "Role-specific date if available",
    description:
      "Configured MS Teams for users migrated from Skype for Business, including setting up auto attendants and call queues in the MS Teams Admin Center. Streamlined user onboarding by automating configuration tasks with PowerShell and improved communication efficiency through effective setup of call management features.",
    image: "https://etimg.etb2bimg.com/photo/98204677.cms",
    tags: ["PowerShell", "MS Teams"],
    category: "",
    github: "", // Add GitHub URL if available
  },
  {
    id: 10,
    title: "Pulse",
    date: "Jun 2026",
    description:
      "A full-stack developer community platform featuring secure JWT authentication with refresh token rotation, real-time feed updates using Server-Sent Events (SSE), infinite scrolling, user profiles, follow/unfollow functionality, likes, notifications, image uploads via Cloudinary, and a modern responsive UI powered by React Query and Zustand.",
    image: "Pulse.png",
    tags: [
      "ReactJS",
      "Tailwind CSS",
      "JavaScript",
      "TanStack Query",
      "Zustand",
      "Axios",
      "NodeJS",
      "ExpressJS",
      "MongoDB",
      "JWT",
      "Server-Sent Events (SSE)",
      "Cloudinary",
      "Vercel",
      "Railway",
    ],
    category: "live app",
    github: "https://github.com/savitaar0912/pulse",
    webapp: ["https://pulse-client-six.vercel.app"],
  },
  {
    id: 11,
    title: "Vibez Estates",
    date: "Jun 2026",
    description:
      "A modern real estate website showcasing managed farmlands, luxury villas, and revenue-generating property opportunities. Features immersive project pages, property highlights, investment-focused content, responsive navigation, animated sections, enquiry and demo forms, and direct WhatsApp and call integrations for prospective buyers.",
    image: "VibezEstate.png",
    tags: [
      "ReactJS",
      "HTML",
      "CSS",
      "Tailwind CSS",
      "JavaScript",
      "Vite",
      "Framer Motion",
      "Responsive Design",
    ],
    category: "live app",
    github: "https://github.com/savitaar0912/VIBEZZ",
    webapp: "https://vibezestates.com/",
  },
  {
    id: 3,
    title: "Amazon",
    date: "Jul 2023 - Jun 2023",
    description:
      "An Amazon clone with all the relevant features like Products, Checkout, Order History, Payment gateway using StripeJS",
    image: "Amazon.png",
    tags: [
      "HTML",
      "CSS",
      "Bootstrap",
      "JavaScript",
      "MongoDB",
      "Firebase",
      "NodeJs",
      "ExpressJS",
      "ReactJS",
      "Redux",
      "Stripe.JS",
    ],
    category: "live app",
    github: "https://github.com/savitaar0912/amazon",
    webapp: ["https://aclone-2c628.web.app"],
  },
  {
    id: 9,
    title: "Uber",
    date: "Jan 2025 - Feb 2025",
    description:
      "An Uber clone with all the relevant features like Login, GoogleMaps, Location Auto Complete, Directions and Hard Coded Ride Fare",
    image: "Uber.png",
    tags: [
      "HTML",
      "Tailwind CSS",
      "Material UI",
      "JavaScript",
      "NextJS",
      "ReactJS",
      "Redux",
      "Firebase",
    ],
    category: "live app",
    github: "https://github.com/savitaar0912/uber",
    webapp: ["https://uber-76a43.web.app"],
  },
  {
    id: 10,
    title: "WhatsApp",
    date: "Aug 2024 - Sept 2024",
    description:
      "A WhatsApp clone with all the relevant features like Login, Multiple Users, Live Chat using Socket.io with Timing",
    image: "Whatsapp.png",
    tags: [
      "HTML",
      "Tailwind CSS",
      "Material UI",
      "JavaScript",
      "ReactJS",
      "Redux",
      "Firebase",
      "Socket.IO",
      "MongoDB",
      "NodeJS",
      "ExpressJS",
    ],
    category: "",
    github: "https://github.com/savitaar0912/whatsapp",
    webapp: [""],
  },
  {
    id: 4,
    title: "Disney+ Hotstar",
    date: "Feb 2023 - Mar 2023",
    description:
      "Disney+ Hotstar clone featuring Indian subscription video-on-demand service, covering domestic Indian film, television, sports content, and imported Southeast Asia content.",
    image: "Hotstar.png",
    tags: [
      "HTML",
      "CSS",
      "Bootstrap",
      "JavaScript",
      "Firebase",
      "ReactJS",
      "Redux",
    ],
    category: "live app",
    github: "https://github.com/savitaar0912/hostar-clone",
    webapp: "https://hotstar-clone-553b2.web.app/",
  },
  {
    id: 5,
    title: "Spotify",
    date: "Jan 2023 - Mar 2023",
    description:
      "Spotify clone featuring Swedish audio streaming service with features for user subscriptions and active monthly users, using Firebase and React.",
    image: "Spotify.png",
    tags: ["HTML", "CSS", "Bootstrap", "JavaScript", "Firebase", "ReactJS"],
    category: "live app",
    github: "https://github.com/savitaar0912/Spotify-Clone",
    webapp: "https://spotify-3b610.web.app/",
  },
  {
    id: 6,
    title: "Space-X",
    date: "May 2023 - Jun 2023",
    description:
      "Expense Tracking App on Playstore with 100+ Downloads. Features include budget planning and Google Drive Cloud API for user database backup, built using Kotlin in MVVM architecture.",
    image: "Space-X.png",
    tags: ["HTML", "CSS", "Bootstrap", "JavaScript", "Firebase", "ReactJS"],
    category: "live app",
    github: "https://github.com/savitaar0912/Space-X-Clone",
    webapp: "https://space-x-be5cd.web.app/",
  },
  {
    id: 7,
    title: "Daily Buggle",
    date: "Mar 2022 - Apr 2022",
    description:
      "News app representing all genres of news, connecting articles from around the world and delivering them to users efficiently and visually.",
    image: "DailyBuggle.png",
    tags: ["HTML", "CSS", "Bootstrap", "ReactJS", "JavaScript"],
    category: "",
    github: "https://github.com/savitaar0912/Dailybuggle",
  },
  {
    id: 8,
    title: "Text Editor",
    date: "Nov 2021",
    description:
      "Free text editor app with features like syntax highlighting, font options, word wrap, printing, undo/redo, keyboard shortcuts, and Google Drive integration.",
    image: "Texteditor.png",
    tags: ["HTML", "CSS", "Bootstrap", "ReactJS", "JavaScript"],
    category: "",
    github: "https://github.com/savitaar0912/Text-Editor",
  },
];

export const TimeLineData = [
  { year: 2021, text: "Started my journey as Software Developer" },
  { year: 2021, text: "Worked as a Frontend developer" },
  { year: 2021, text: "Founded React Mastery" },
  { year: 2021, text: "Made React & MERN projects" },
];
